export default {
    noticeFlag: state => state.noticeFlag,
}